module.exports = "/_next/static/images/mandiri-logo-87bd609bc98760cf5d47322998f20b68.svg";